module.exports = __webpack_public_path__ + "8718772707e165feff05961a0c99014e.MP3";